import {getUriLangCode} from "../reducers/i18n";
import * as types from "./actionTypes";

export const setLanguageFromURI = ( language ) => ({
    type    : types.LOCALE_SETTED_FROM_URI,
    language: language
});

export const changeLanguage = ( language ) => ({
    type           : types.LOCALE_CHANGED,
    currentLanguage: language
});

export const setLanguage = ( language ) => {
    return ( dispatch, getState ) => {
        const {code} = getState().stolo.i18n.currentLanguage;
        if ( language === code ) {
            return Promise.resolve();
        }

        dispatch( changeLanguage( language ) );

        const uriLanguage = getUriLangCode( getState() );
        const location = getState().location;
        const payload = Object.assign( {}, location.payload, {language: uriLanguage} );
        dispatch(
            {
                type   : location.type,
                payload: payload,
            }
        );
    }
};

export const setLocaleFromRoute = ( {dispatch, getState, action} ) => {

    const uriLocale = action.payload.language ? action.payload.language : null;
    const currentLocale = getState().stolo.i18n.currentLang;
    if ( locale === currentLocale ) {
        return Promise.resolve();
    }

    const locale = uriLocale + "-" + uriLocale.toUpperCase();

    dispatch( changeLanguage( locale ) );
};




// WEBPACK FOOTER //
// ./src/actions/i18n.js